import { Component, OnDestroy, OnInit, Input,SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-view-video-compatibility',
  templateUrl: './view-video-compatibility.component.html',
  styleUrls: ['./view-video-compatibility.component.scss'],
})
export class ViewVideoCompatibilityComponent implements OnInit, OnDestroy {
  @Input() viewVideoCompatibility = [];


  constructor(
  ){}

  ngOnInit(): void {
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes && changes.viewVideoCompatibility && changes.viewVideoCompatibility.currentValue && changes.viewVideoCompatibility.currentValue !== changes.viewVideoCompatibility.previousValue){
      this.viewVideoCompatibility = changes.viewVideoCompatibility.currentValue;
    }
  }

  ngOnDestroy(): void {
  }

}

